import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * Requisição da lista sinais de tendências.
 * @param {Object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Lista de sinais.
 */
const GetSignalsList = function(parameters)
{
	const params = {};
	params.componentType = parameters.component;

	return httpV2.get(`/WindTurbineVDI/${parameters.monitoringElementId}/TrendSignalSettings`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição do pior caso de IDV.
 * @param {Object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Sinal com pior IDV.
 */
const GetWorstVDI = function(parameters)
{
	const params = {};
	params.componentType = parameters.component;

	return httpV2.get(`/WindTurbineVDI/${parameters.monitoringElementId}/WorstVDI`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição de dados do gráfico de tendências.
 * @param {Object} parameters Objeto de parâmetros passados por query na requisição.
 * @returns Dados para construção do gráfico.
 */
const GetTrendChart = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/WindTurbineVDIChart/${parameters.signalSettingId}/Trends`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição de dados do gráfico de boxplot.
 * @param {Object} parameters Objeto de parâmetros passados por query na requisição.
 * @returns Dados para construção do gráfico.
 */
const GetBoxPlotChart = function(parameters)
{
	const params = {};
	params.trendSignalSettingsIds = parameters.signalSettingId;
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get("/WindTurbineVDIChart/BoxPlot",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição de download do IDV em .csv.
 * @param {array} monitoringElementIds Ids dos elementos de monitoramentos do tipo turbina.
 * @param {string} startDateTime Data/hora de início.
 * @param {string} endDateTime  Data/hora de fim.
 * @param {string} fileName Nome do arquivo.
 * @returns {object} Arquivo no formato csv para download.
 */
const Download = function(monitoringElementIds, startDateTime, endDateTime, fileName)
{
	return httpV2.post(`/WindTurbineVDI/DownloadVDIsCSV?
		startDateTime=${startDateTime}&endDateTime=${endDateTime}&fileName=${fileName}`,
	monitoringElementIds);
};

export default
{
	GetSignalsList,
	GetWorstVDI,
	GetTrendChart,
	GetBoxPlotChart,
	Download,
};